/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptySearchIcon = createIcon("EmptySearchIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M51 33c14.912 0 27 12.088 27 27a26.9 26.9 0 01-6.934 18.066L83 90a1.414 1.414 0 11-2 2L69.066 80.066A26.9 26.9 0 0151 87c-14.912 0-27-12.088-27-27s12.088-27 27-27Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 80c14.36 0 26-11.64 26-26S71.36 28 57 28 31 39.64 31 54s11.64 26 26 26Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 27c14.912 0 27 12.088 27 27a26.9 26.9 0 01-6.934 18.066L89 84a1.414 1.414 0 11-2 2L75.066 74.066A26.9 26.9 0 0157 81c-14.912 0-27-12.088-27-27s12.088-27 27-27Zm0 2c-13.807 0-25 11.193-25 25s11.193 25 25 25 25-11.193 25-25-11.193-25-25-25Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 36c.676 0 1.344.037 2 .11-9 .994-16 8.625-16 17.89s7 16.896 16 17.89c-.656.073-1.324.11-2 .11-9.941 0-18-8.059-18-18s8.059-18 18-18Z",
    fill: "#CFCEFD"
  }));
}, {
  "i18nKey": "svg.EmptySearchIcon"
});